import $c from '@/services/api/lib/container'

export default {
  loadTaxonomy (data) {
    let _sortBy = data.descending ? '-' : ''
    _sortBy += data.sortBy

    let taxonomyResource = $c.get('taxonomy')

    if (data.filters && data.filters.length > 0) {
      taxonomyResource = taxonomyResource.loadFilters(data.filters)
    }

    return taxonomyResource
      .include(['children', 'parent', 'products'])
      .page(data.page || 1)
      .limit(data.rowsPerPage || 25)
      .orderBy(_sortBy)
      .get()
  },

  loadOnlyProducts (data) {
    let _sortBy = data.descending ? '-' : ''
    _sortBy += data.sortBy

    return $c.get('product')
      .page(data.page || 1)
      .limit(data.rowsPerPage || 25)
      .orderBy(_sortBy)
      .getFullData()
  },

  loadOnlyTaxonomy (data) {
    let _sortBy = data.descending ? '-' : ''
    _sortBy += data.sortBy

    return $c.get('taxonomy')
      .page(data.page || 1)
      .limit(data.rowsPerPage || 25)
      .orderBy(_sortBy)
      .getFullData()
  },

  loadOnlyCommonProducts (data) {
    let _sortBy = data.descending ? '-' : ''
    _sortBy += data.sortBy

    return $c.get('product')
      .where('classification', 'eq', 'common')
      .page(data.page || 1)
      .limit(data.rowsPerPage || 25)
      .orderBy(_sortBy)
      .getFullData()
  },

  searchCommonProducts (data, search) {
    let _sortBy = data.descending ? '-' : ''
    _sortBy += data.sortBy

    return $c.get('product')
      .where('classification', 'eq', 'common')
      .page(data.page || 1)
      .limit(data.rowsPerPage || 25)
      .where('name', 'like', search)
      .orderBy(_sortBy)
      .getFullData()
  }
}
